import { MethodType, ParamsFetchType, GenerateUrlApiType, ResponseType } from 'src_common/browser/apiUtils';
import { fetchGet } from 'src_common/common/realtime-server/fetch';
import { GenerateUrlApiParamsType, GenerateUrlApiParamsWithSessionIdType } from 'src_common/server/webDriver/sdkApiWebUtils';
import * as t from 'io-ts';
import { buildValidator } from 'src_common/common/mobx-utils/buildValidator';



const SuccessResponseIO = t.interface({
    status: t.literal(200),
    bodyJson: t.unknown,
});

const decodeSuccessResponse = buildValidator('SuccessResponse', SuccessResponseIO);

const ErrorResponseIO = t.interface({
    status: t.literal(400),
    bodyJson: t.unknown,
});

type ErrorResponseType = t.TypeOf<typeof ErrorResponseIO>;

type SuccessResponseType = {
    status: 200,
    bodyJson: unknown
};

const decodeResponseError = buildValidator('play break -> ResponseIO', ErrorResponseIO, true);


const decodeGetBankingData = (data: unknown): SuccessResponseType | ErrorResponseType | Error => {
    const dataSuccess = decodeSuccessResponse(data);

    if (dataSuccess instanceof Error) {
        return decodeResponseError(data);
    } else {
        return {
            status: 200,
            bodyJson: dataSuccess.bodyJson
        };
    }
};

const additionalRequestForBanking = async (params: GenerateUrlApiParamsWithSessionIdType): Promise<unknown> => {

    const response = await fetchGet({
        url: `${params.API_URL}/banking-configs/${params.API_UNIVERSE}`,
        backendToken: params.jwtToken,
        decode: decodeGetBankingData
    });

    return response.bodyJson;
};




const decode = (status: number, data: ResponseType): unknown => {
    if (status === 200 || status === 201) {
        return;
    }

    throw new Error(`unhandled response ${status} - ${data.type}`);
};

export interface PostPutParamsWithdrawalRuleType {
    automaticWithdrawalEnabled: boolean
}

export const putAutomaticWithdrawal = {
    browser: {
        params: (params: PostPutParamsWithdrawalRuleType): ParamsFetchType<PostPutParamsWithdrawalRuleType> => {
            return {
                type: MethodType.POST,
                url: '/api-web/automatic-withdrawal/change',
                body: params
            };
        },
        decode: decode
    },
    express: {
        method: MethodType.POST,
        urlBrowser: '/api-web/automatic-withdrawal/change',
    },
    generateUrlApi: async (params: GenerateUrlApiParamsType<PostPutParamsWithdrawalRuleType>): Promise<GenerateUrlApiType> => {

        if (params.userSessionId === null) {
            return {
                passToBackend: false,
                status: 403,
                responseBody: {
                    errorMessage: 'User id invalid',
                }
            };
        }

        const bankingParams = {
            API_URL: params.API_URL,
            API_UNIVERSE: params.API_UNIVERSE,
            jwtToken: params.jwtToken,
            userSessionId: params.userSessionId
        };
        const additionalResponseForWallet = await additionalRequestForBanking(bankingParams);
        const { automaticWithdrawalEnabled } = params.req.body;

        //@ts-expect-error
        const body = Object.assign(additionalResponseForWallet, { automaticWithdrawalEnabled });

        return {
            url: `${params.API_URL}/banking-configs/${params.API_UNIVERSE}`,
            passToBackend: true,
            method: MethodType.PUT,
            body: body
        };
    }
};

